<template>
    <div class="text-center p-1 w-full">
        <div
            class="border w-full cursor-pointer hover:border-gray-400 tranisiton-all px-4 pb-3 rounded-lg"
            @click="option.show = true"
        >
            <span class="flex items-center justify-center w-full">
                <div class="inline-block">
                    <div class="group block">
                        <strong class="inline-block">{{ option.value }}</strong>
                        <fa
                            :icon="['fas', 'info-circle']"
                            class="ml-1 text-dgreen2 w-4 h-4 inline-block group-hover:text-blue-700 group-hover:font-bold"
                        />
                    </div>

                    <teleport to="#modals">
                        <modal :title="option.value" :show="option.show ? true : false" @close="close">
                            <template v-slot:content>
                                <div class="w-full flex flex-wrap">
                                    <div class="w-full md:w-1/2">
                                        <!-- <strong>{{ title }}</strong> -->
                                        <img :src="option.image.origin_src" class="h-40" />
                                        <p class="md:pr-12">{{ option.description }}</p>
                                        <div class="mt-4 block">
                                            Prijs:
                                            <strong>{{ price(option.price) }}</strong>
                                        </div>
                                    </div>
                                    <div
                                        class="w-full md:w-1/2 md:border-l md:pl-12 pt-4 mt-4 md:mt-0 md:pt-0 border-t md:border-t-0"
                                        v-if="option.tech_image"
                                    >
                                        <strong>Technische tekening</strong>
                                        <img :src="option.tech_image.origin_src" />
                                    </div>
                                </div>
                            </template>
                        </modal>
                    </teleport>
                </div>
            </span>
            <vue-picture
                :image="option.image"
                :name="option.value"
                :style="'mx-auto max-h-24'"
                :fph="false"
                :height="150"
            ></vue-picture>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    option: Object,
    title: String,
});

function close() {
    props.option.show = false;
}
</script>
